import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _isObject from "lodash/isObject";

/**
 * Create an empty object or array based on what the input type is. This is
 * useful when deep cloning objects.
 */
var createEmptyObjectOrArray = function createEmptyObjectOrArray(source) {
  if (Array.isArray(source)) {
    return [];
  }

  return {};
};
/**
 * Utility function to merge properties from a source object into a target
 * object. This is used to merge payload decorators into an event payload
 * object.
 *
 * This function is designed to minimize the number of object allocations
 * needed when applying payload decorators while at the same time ensuring no
 * part of the payload input argument is mutated. This is done by first making
 * a deep clone of the input argument:
 *
 *     const clonedPayload = {};
 *     deepMergeInto(clonedPayload, payload);
 *
 * And then mutating the cloned payload with each decorator:
 *
 *    deepMergeInto(clonedPayload, decorator1);
 *    deepMergeInto(clonedPayload, decorator2);
 *    // ...
 *
 * This avoids object allocation for each intermediate instance of the
 * payload.
 */


var deepMergeInto = function deepMergeInto(target, source) {
  /* eslint-disable no-param-reassign */
  if (source != null) {
    Object.keys(source).forEach(function (prop) {
      if (_isObject(source[prop])) {
        if (!_isObject(target[prop])) {
          // If an object doesn't already exist on the target, create a new
          // one. This prevents future mutations on target to affect source.
          target[prop] = createEmptyObjectOrArray(source[prop]);
        }

        deepMergeInto(target[prop], source[prop]);
      } else {
        target[prop] = source[prop];
      }
    });
  }

  return target;
  /* eslint-enable no-param-reassign */
};

export default deepMergeInto;